import { RefreshIcon } from './RefreshIcon';

/**
 * author: Google
 * id AD3C7A2B-0B64-4183-9452-C96EAAF3E08E
 * name refresh
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/refresh.svg
 * tags
 * - Arrow 
 */
export const LoopIcon = RefreshIcon;
export default LoopIcon